module.exports = __webpack_public_path__ + "static/media/wheat.a894daa6.jpg";